// src/context/AuthContext.jsx

import React, {

  createContext,

  useState,

  useContext,

  useEffect,

} from "react";

import { toast }
from "react-toastify";

const AuthContext =
  createContext();

export const AuthProvider =
({ children }) => {

const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000/api"
    : "https://backend.sacmtb.com/api";

  /* =====================================================
  RESTORE SESSION
  ===================================================== */

  const [user,
    setUser] =
    useState(() => {

      try {

        const saved =
          JSON.parse(

            localStorage.getItem(
              "user"
            )
          );

        if (!saved)
          return null;

        if (
          saved.id &&
          !saved._id
        ) {

          saved._id =
            saved.id;
        }

        return saved;

      } catch {

        return null;
      }
    });

  const [token,
    setToken] =
    useState(

      localStorage.getItem(
        "token"
      ) || null
    );

  const [emailForOtp,
    setEmailForOtp] =
    useState("");

  /* =====================================================
  SAVE SESSION
  ===================================================== */

  const saveSession =
  (userData, jwtToken) => {

    if (!jwtToken)
      return;

    const finalUser = {

      _id:
        userData._id ||
        userData.id,

      name:
        userData.name,

      email:
        userData.email,

      phone:
        userData.phone,

      avatar:
        userData.avatar,

      isAdmin:
        userData.isAdmin ||
        false,
  participationId: userData.participationId || null,

  riderNumber: userData.riderNumber || null,

  gameRegistered: userData.gameRegistered || false,

      token: jwtToken,
    };

    localStorage.setItem(

      "user",

      JSON.stringify(
        finalUser
      )
    );

    localStorage.setItem(
      "token",
      jwtToken
    );

    setUser(finalUser);

    setToken(jwtToken);
  };

  /* =====================================================
  REGISTER
  ===================================================== */

  const register =
  async (
    name,
    email,
    phone,
    password
  ) => {

    try {

      const res =
        await fetch(

          `${API_URL}/users/register`,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json",
            },

            body: JSON.stringify({

              name,

              email,

              phone,

              password,
            }),
          }
        );

      const data =
        await res.json();

      if (res.ok) {

        setEmailForOtp(
          email
        );

        localStorage.setItem(

          "pendingPassword",

          password
        );

        toast.success(
          "OTP sent to your email!"
        );

        return {
          success:true
        };
      }

      toast.error(
        data.message
      );

      return {
        success:false
      };

    } catch {

      toast.error(
        "Server error"
      );

      return {
        success:false
      };
    }
  };

  /* =====================================================
  VERIFY OTP
  ===================================================== */

  const verifyOtp = async (email, otp) => {

    try {

        const res = await fetch(
            `${API_URL}/users/verify-otp`,
            {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    email,
                    otp
                })
            }
        );

        const data = await res.json();

        console.log("=================================");
console.log("VERIFY OTP API RESPONSE");
console.log(data);
console.log("Token:", data.token);
console.log("User:", data.user);
console.log("=================================");

        if(!res.ok){

            toast.error(data.message);

            return {success:false};

        }

        saveSession(
            data.user,
            data.token
        );

        localStorage.removeItem(
            "pendingPassword"
        );

        toast.success(
            "Account verified successfully!"
        );

        return {
            success:true,
            token:data.token,
            user:data.user
        };

    }catch{

        toast.error("Server error");

        return {
            success:false
        };

    }

};

      

    

  /* =====================================================
  LOGIN
  ===================================================== */

  const login =
  async (
    email,
    password
  ) => {

    try {

      const res =
        await fetch(

          `${API_URL}/users/login`,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json",
            },

            body: JSON.stringify({

              email,

              password,
            }),
          }
        );

      const data =
        await res.json();

      if (res.ok) {

        saveSession(

          data.user,

          data.token
        );

        toast.success(

          `Welcome back ${data.user.name}!`
        );

        return {
          success:true
        };
      }

      toast.error(
        data.message
      );

      return {
        success:false
      };

    } catch {

      toast.error(
        "Server error"
      );

      return {
        success:false
      };
    }
  };

  /* =====================================================
  FORGOT PASSWORD
  ===================================================== */

  const forgotPassword =
  async (email) => {

    try {

      const res =
        await fetch(

          `${API_URL}/users/forgot-password`,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json",
            },

            body: JSON.stringify({
              email
            }),
          }
        );

      const data =
        await res.json();

      if (res.ok) {

        toast.success(
          "Password reset OTP sent!"
        );

        return {
          success:true
        };
      }

      toast.error(
        data.message
      );

      return {
        success:false
      };

    } catch {

      toast.error(
        "Server error"
      );

      return {
        success:false
      };
    }
  };

  /* =====================================================
  RESET PASSWORD
  ===================================================== */

  const resetPassword =
  async (
    email,
    otp,
    newPassword
  ) => {

    try {

      const res =
        await fetch(

          `${API_URL}/users/reset-password`,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json",
            },

            body: JSON.stringify({

              email,

              otp,

              newPassword,
            }),
          }
        );

      const data =
        await res.json();

      if (res.ok) {

        toast.success(
          "Password changed successfully!"
        );

        return {
          success:true
        };
      }

      toast.error(
        data.message
      );

      return {
        success:false
      };

    } catch {

      toast.error(
        "Server error"
      );

      return {
        success:false
      };
    }
  };

  /* =====================================================
  GOOGLE LOGIN
  ===================================================== */

  const googleLogin =
  async (credential) => {

    try {

      const res =
        await fetch(

          `${API_URL}/users/google-login`,

          {

            method:"POST",

            headers:{
              "Content-Type":
              "application/json",
            },

            body: JSON.stringify({

              token:
                credential,
            }),
          }
        );

      const data =
        await res.json();

      if (res.ok) {

        saveSession(

          data.user,

          data.token
        );

        toast.success(
          "Google login successful!"
        );

        return {
          success:true
        };
      }

      toast.error(
        data.message
      );

      return {
        success:false
      };

    } catch {

      toast.error(
        "Server error"
      );

      return {
        success:false
      };
    }
  };

  /* =====================================================
  LOGOUT
  ===================================================== */

  const logout = () => {

    localStorage.removeItem(
      "user"
    );

    localStorage.removeItem(
      "token"
    );

    setUser(null);

    setToken(null);

    toast.info(
      "Logged out successfully"
    );
  };

  /* =====================================================
  AUTO RESTORE
  ===================================================== */

  useEffect(() => {

    try {

      const savedUser =
        JSON.parse(

          localStorage.getItem(
            "user"
          )
        );

      const savedToken =
        localStorage.getItem(
          "token"
        );

      if (
        savedUser &&
        savedToken
      ) {

        if (
          savedUser.id &&
          !savedUser._id
        ) {

          savedUser._id =
            savedUser.id;

          localStorage.setItem(

            "user",

            JSON.stringify(
              savedUser
            )
          );
        }

        setUser(savedUser);

        setToken(savedToken);
      }

    } catch {

      localStorage.removeItem(
        "user"
      );

      localStorage.removeItem(
        "token"
      );
    }

  }, []);

  /* =====================================================
  PROVIDER
  ===================================================== */

  return (

    <AuthContext.Provider

      value={{

        user,

        token,

        emailForOtp,

        setEmailForOtp,

        register,

        verifyOtp,

        login,

        googleLogin,

        forgotPassword,

        resetPassword,

        logout,

        setUser,
      }}
    >

      {children}

    </AuthContext.Provider>
  );
};

export const useAuth =
() => useContext(AuthContext);